export default "__VITE_ASSET__BlwWVo$b__"